import { _js } from '@ifixit/localize';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Bell, BellSolid } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import NotificationsDisplay from './notifications_display';
import Notifications from 'Shared/Notifications/notifications';

const Icon = styled(Bell)`
   cursor: pointer;
   color: ${color.gray[400]};
`;

const UnreadIcon = styled(BellSolid)`
   cursor: pointer;
   color: ${color.gray[50]};
`;

function NotificationsDropdown({
   notifications,
   notificationsUrl,
}: {
   notifications: Notifications;
   notificationsUrl: string;
}) {
   const unreadNotifications = notifications.getUnreadNotifications();
   const hasUnread = unreadNotifications.length != 0;

   const dropdownIcon = hasUnread ? (
      <UnreadIcon aria-label="unread notifications dropdown" focusable="false" />
   ) : (
      <Icon aria-label="notifications dropdown" focusable="false" />
   );

   return (
      <Dropdown icon={dropdownIcon} hasBadge={hasUnread}>
         {hasUnread ? (
            <NotificationsDisplay
               unreadNotifications={unreadNotifications}
               notificationsUrl={notificationsUrl}
               markAllRead={notifications.markAllRead}
            />
         ) : (
            <p>{_js('No notifications!')}</p>
         )}
      </Dropdown>
   );
}

export default NotificationsDropdown;
